import React, { useState } from 'react';
import {
  MESES_CORTOS, MESES_LARGOS, mesesGA07, aniosGA07, informesSinFecha, primerDiaMes,
  type InformeGA07,
} from '../lib/ga07-meses';
import { hoyISO } from '../lib/sso-documentos';
import './MesesGA07.css';

// Fila de 12 meses de GA-07 (bloque 5d, D): en la tarjeta del Checklist y en
// Documentos SSO filtrado por GA-07. Verde = hay informe con "Aprobado desde"
// en ese mes (se abre); gris = falta (abre Subir con ese mes); futuro = sin color.
export default function MesesGA07({ informes, onAbrir, onSubir, hoy = hoyISO() }: {
  informes: InformeGA07[];
  onAbrir: (informe: InformeGA07) => void;
  /** Sin esta función (no puede subir) los meses que faltan no se pueden tocar. */
  onSubir?: (aprobadoDesde: string) => void;
  hoy?: string;
}) {
  const anios = aniosGA07(informes, hoy);
  const [anio, setAnio] = useState(anios[0]);
  const meses = mesesGA07(informes, anio, hoy);
  const sinFecha = informesSinFecha(informes);

  return (
    <div className="ga07-meses">
      <div className="ga07-meses-cabecera">
        <span className="ga07-meses-titulo">Informes mensuales</span>
        <label className="ga07-meses-anio">
          <span className="ga07-sr">Año</span>
          <select value={anio} onChange={e => setAnio(Number(e.target.value))}>
            {anios.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </label>
      </div>
      <div className="ga07-meses-fila" role="group" aria-label={`Informes GA-07 de ${anio}`}>
        {meses.map(m => {
          const nombre = `${MESES_LARGOS[m.mes - 1]} de ${anio}`;
          const tocable = m.estado === 'con_informe' || (m.estado === 'falta' && !!onSubir);
          const titulo = m.estado === 'con_informe' ? `${nombre}: informe subido. Abrir.`
            : m.estado === 'futuro' ? `${nombre}: todavía no llega`
            : onSubir ? `${nombre}: falta el informe. Subir.` : `${nombre}: falta el informe`;
          return (
            <button
              key={m.mes}
              type="button"
              className={`ga07-mes ga07-mes-${m.estado}`}
              disabled={!tocable}
              title={titulo}
              aria-label={titulo}
              onClick={() => {
                if (m.informe) onAbrir(m.informe);
                else if (m.estado === 'falta') onSubir?.(primerDiaMes(anio, m.mes));
              }}
            >
              {MESES_CORTOS[m.mes - 1]}
            </button>
          );
        })}
      </div>
      <p className="ga07-meses-nota">
        Verde: hay un informe con "Aprobado desde" en ese mes. Gris: falta.
        {sinFecha > 0 && ` ${sinFecha} informe${sinFecha === 1 ? '' : 's'} sin "Aprobado desde" no se cuenta${sinFecha === 1 ? '' : 'n'} (complétalo con Editar).`}
      </p>
    </div>
  );
}
